import {
  VuexModule,
  Module,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "./index";
import * as LineItemModel from "@/models/campaign";
import { cloneDeep } from "lodash";
import ObjectsHelper from "@/helpers/objects";

export interface LineItemState {
  currentLineItem?: LineItemModel.LineItem | null;
  lineItems: LineItemModel.LineItem[];
  selectedLineItems: LineItemModel.LineItem[];
}

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "lineItem",
})
class LineItem extends VuexModule implements LineItemState {
  currentLineItem: LineItemModel.LineItem | undefined = undefined;
  lineItems: LineItemModel.LineItem[] = [];
  selectedLineItems: LineItemModel.LineItem[] = [];

  get getCurrentLineItem() {
    return this.currentLineItem;
  }

  get getLineItems() {
    return this.lineItems;
  }

  get getSelectedLineItems() {
    return this.selectedLineItems;
  }

  @Mutation
  addLineItem(lineItem: LineItemModel.LineItem) {
    let exists: LineItemModel.LineItem | undefined = undefined;
    if (lineItem.id !== "") {
      exists = this.lineItems.find((el: LineItemModel.LineItem) => {
        return el.id === lineItem.id;
      });
    } else {
      exists = this.lineItems.find((el: LineItemModel.LineItem) => {
        return el.localId === lineItem.localId;
      });
    }

    exists === undefined ? this.lineItems.push(lineItem) : null;
  }

  @Mutation
  setCurrentLineItem(lineItem: LineItemModel.LineItem) {
    this.currentLineItem = cloneDeep(lineItem);
  }

  @Mutation
  setLineItems(lineItems: LineItemModel.LineItem[]) {
    this.lineItems = lineItems;
  }

  @Mutation
  setSelectedLineItems(lineItems: LineItemModel.LineItem[]) {
    this.selectedLineItems = lineItems;
  }

  @Mutation
  updateLineItem(lineItem: LineItemModel.LineItem) {
    this.lineItems.forEach((item: LineItemModel.LineItem, idx: number) => {
      if (lineItem.id !== "") {
        if (item.id === lineItem.id) {
          ObjectsHelper.updateProperties(this.lineItems[idx], lineItem);
        }
      } else {
        if (item.localId === lineItem.localId) {
          ObjectsHelper.updateProperties(this.lineItems[idx], lineItem);
        }
      }
    });
  }

  // @Mutation
  // unsetCurrentLineItem() {
  //   this.currentLineItem = undefined;
  // }
}

export const LineItemModule = getModule(LineItem);
